// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__1T5PX","Label":"Checkbox_Label__2Tug3","InputElement":"Checkbox_InputElement__3bz2Q","Invalid":"Checkbox_Invalid__261Go"};